import { render, staticRenderFns } from "./filter-component.vue?vue&type=template&id=2471165b&"
import script from "./filter-component.vue?vue&type=script&lang=js&"
export * from "./filter-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports